import React from "react";

export default function MSAccess_Format() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Format</h1>
      <p>This is the MSAccess_Format component generated from the SQL JSON.</p>
    </div>
  );
}
